<template>
	<vs-popup
		:title="$t('choosePenaltyReason')"
		class="primary-popup set-ticket-failed"
		:active.sync="activeProp"
	>
		<ul class="leftx set-ticket-failed__list">
			<li v-for="(item, index) in penaltyReasons" :key="index">
				<vs-radio
					v-model="reason"
					:vs-value="item.id"
					class="set-ticket-failed__item"
					>{{ item.name }}</vs-radio
				>
			</li>
		</ul>

		<div class="mt-3 px-2">
			<vs-input
				:label="$t('order') + ' №'"
				v-model="orderId"
				class="amount-input"
			/>

			<vs-checkbox v-model="warning" class="mx-0 my-3">
				{{ $t("warning") }}
			</vs-checkbox>

			<div class="form-input">
				<vs-input
					v-if="!warning"
					v-model="amount"
					:label="$t('penaltySum')"
					class="amount-input"
					name="amount"
				/>
        
				<span
					v-if="this.amount > this.maxValue"
					class="text-danger text-sm"
				>
					{{ $t("maxValue", { n: maxValue }) }}
				</span>
			</div>
		</div>

		<div class="set-ticket-failed__controls">
			<vs-button
				:disabled="!reason || !orderId || disableSubmit"
				class="mr-1"
				color="primary"
				@click="confirm"
			>
				{{ $t("save") }}
			</vs-button>

			<vs-custom-button @click="close" color="#9a9a9a" type="flat">
				{{ $t("cancel") }}
			</vs-custom-button>
		</div>
	</vs-popup>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";

export default {
	name: "PenaltyPopup",
	mixins: [databaseManager],
	props: {
		active: { default: false, type: Boolean },
		recommendedPrice: { default: 0 },
		maxValue: { type: Number }
	},
	data() {
		return {
			reason: null,
			penaltyReasons: [],
			amount: 0,
			orderId: null,
			warning: false
		};
	},
	watch: {
		activeProp(newValue) {
			if (newValue === false) {
				this.reason = null;
				this.amount = 0;
				this.orderId = null;
				this.warning = false;
			}
		}
	},
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		},

		disableSubmit() {
			if (!this.maxValue) {
				return false;
			}

			return this.amount > this.maxValue;
		}
	},
	methods: {
		confirm() {
			if (this.reason === null) return;
			const amount = this.warning ? null : this.amount;
			this.$emit("confirm", {
				reason: this.reason,
				orderId: this.orderId,
				amount
			});
			this.activeProp = false;
		},
		close() {
			this.activeProp = false;
		}
	},
	async mounted() {
		this.penaltyReasons = await this.dbGetPenaltyReasons();
	}
};
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-failed {
	&__title {
		padding-left: 8px;
		padding-right: 8px;
	}

	&__list {
		padding-left: 8px;
		padding-right: 8px;
		margin-top: 7px;
	}

	&__item {
		margin-top: 5px;
	}

	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 450px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
		}

		&--close,
		&--title h3 {
			color: $primary;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}
	.amount-input {
		width: 100%;
	}
}
</style>
